const WARNING_BEFORE_IDLE_MS = 60 * 1000; // 1 min – warning countdown duration

/**
 * Auto logout timeout durations (in milliseconds)
 * INACTIVITY_TIMEOUT: Total time before logout (15 minutes by default - can be overridden in the environment variable)
 * WARNING_BEFORE_IDLE: Warning countdown duration (1 minute)
 *
 * Safeguard: INACTIVITY_TIMEOUT is always at least WARNING_BEFORE_IDLE + 60s so the warning bar
 * can appear (react-idle-timer prompts "promptBeforeIdle" before idle; if timeout were 30s and
 * prompt 60s, the prompt would never fire and you'd get logout with no warning).
 *
 * Local testing: set VITE_AUTO_LOGOUT_TIME_AFTER_INACTIVITY=120000 (2 min total) so the warning
 * appears after 1 minute of inactivity instead of 14 minutes.
 */
export const AUTO_LOGOUT_TIMES = {
  INACTIVITY_TIMEOUT: (() => {
    const raw =
      Number(import.meta.env.VITE_AUTO_LOGOUT_TIME_AFTER_INACTIVITY) ||
      15 * 60 * 1000; // 15 min default
    return Math.max(raw, WARNING_BEFORE_IDLE_MS + 60 * 1000); // ensure warning phase can run
  })(),
  WARNING_BEFORE_IDLE: WARNING_BEFORE_IDLE_MS,
} as const;
